module.exports = __webpack_public_path__ + "static/images/card-bg-1-type3.91de1ad.png";